import { allowedProtocols } from "tools/validations";

const KEPT_PREFIXES = [...allowedProtocols, "mailto:", "tel:"];

// Same-page and relative links aren't domains — prefixing them produced
// `https:///path` / `https://#anchor`.
const RELATIVE_HREF = /^[/#?]/;

/**
 * A link typed without a scheme (`www.example.com`) is a domain, not a
 * relative path — give it `https://`. Returns `null` when the href is
 * fine as is. Any other scheme (`javascript:` included) is prefixed too,
 * which also defuses it.
 */
const normalizeLinkHref = (href: string | null): string | null => {
  if (!href || RELATIVE_HREF.test(href)) {
    return null;
  }
  const lower = href.toLowerCase();
  if (KEPT_PREFIXES.some((prefix) => lower.startsWith(prefix))) {
    return null;
  }
  return `https://${href}`;
};

export default normalizeLinkHref;
